import React from 'react'
import { Link } from "react-router-dom"
import { Row, Col, Space, Typography, List, Form, Input, InputNumber, Button, Select, Upload, Table, AutoComplete, message } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { reqSnpPrimerPipline } from '../../../api'

const { Option } = Select

class SnpPrimer extends React.Component {
    state = {
        disabled: false,
        list_data: [],
        loading: false,
    }

    formRef = React.createRef()

    onFinish = async (values) => {
        this.setState({
            disabled: true,
            loading: true
        })

        const res = await reqSnpPrimerPipline(values)
        if (res.code === 0) {
            this.setState({
                disabled: false,
                list_data: res.data,
                loading: false
            })
        } else {
            message.error(res.message)
        }
    }

    onReset = () => {
        this.formRef.current.resetFields()
    }

    render() {
        const { disabled, list_data, loading } = this.state

        const layout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 12 },
            colon: false
        }
        const tailLayout = {
            wrapperCol: { offset: 2, span: 12 },
        }

        const props = {
            name: 'file',
            action: 'http://solomics.agis.org.cn/tomato/api/v1/snp_primer_pipline_polymarker',
            onChange({ file, fileList }) {
              if (file.status !== 'uploading') {
                console.log(file, fileList);
              }
            }
        }

        const normFile = (e) => {
            console.log('Upload event:', e);
            if (Array.isArray(e)) {
              return e;
            }
            return e && e.fileList;
        }

        return (
            <React.Fragment>
                <Form {...layout} name="snp-primer" layout="vertical" ref={this.formRef} className="snp-primer-form" onFinish={this.onFinish}>
                    <Form.Item name="polymarker" valuePropName="fileList" getValueFromEvent={normFile} label="The input file is the same as polymarker." rules={[{ required: true }]} extra="e.g. a csv file with each line like this: 1-117042,1,CAAGCACAAGTGCACTTTCCTGCAGATAACAAGATATTTTGTGTGAGTCA[C/A]TGCTTCAAAAAAACCTTATATTCTAGTTACTACCTCTATTCCATTTAATG">
                        <Upload {...props}>
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                    </Form.Item>
                    <Form.Item name="reference" label="Which reference to use?" initialValue="SL5.0" rules={[{ required: true }]}>
                        <Select allowClear>
                            <Option value="SL5.0">SL5.0</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="ploidy" label="Ploidy" extra="A genome, AB genome, or ABD genome" initialValue="3" rules={[{ required: true }]}>
                        <InputNumber min={1} max={3} style={{ width: 200 }} />
                    </Form.Item>
                    <Form.Item name="max_neb_restriction_enzyme_price" label="Maximum NEB restriction enzyme price(dollars per 1000U)" rules={[{ required: true }]} initialValue="200">
                        <Input />
                    </Form.Item>
                    <Form.Item name="max_primer_tm" label="Maximum Primer Tm" initialValue="63.0" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="max_primer_size" label="Maximum Primer Size(no larger than 36)" initialValue="25" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="is_pick_primer" label="Pick primer anyway?" initialValue="0" rules={[{ required: true }]} extra="If yes, primers will be picked even if it violates specific constraints. Choose this only if you do not get any primers.">
                        <Select allowClear>
                            <Option value="1">Yes</Option>
                            <Option value="0">No</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="is_design_caps_dcaps_primers" label="Design CAPS/dCAPS primers?" rules={[{ required: true }]} initialValue="1" extra="If yes, CAPS/dCAPS primers will be designed.">
                        <Select allowClear>
                            <Option value="1">Yes</Option>
                            <Option value="0">No</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="is_design_kasp_primers" label="Design KASP primers?" initialValue="1" rules={[{ required: true }]} extra="If yes, KASP primers will be designed.">
                        <Select allowClear>
                            <Option value="1">Yes</Option>
                            <Option value="0">No</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                        <Row>
                            <Col span={12}>
                                <Space>
                                    <Button type="primary" disabled={disabled} htmlType="submit" block>
                                        Submit
                                    </Button>
                                    <Button htmlType="button" disabled={disabled} onClick={this.onReset}>
                                        Reset
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
                <List
                    header={<div>Result</div>}
                    bordered
                    loading={loading}
                    dataSource={list_data}
                    renderItem={ (item) => {
                        let file_link = "http://solomics.agis.org.cn/tomato/media/snp_primer_pipline_res/" + item
                        return <List.Item><a href={file_link}>{item}</a></List.Item>
                    }}
                />
            </React.Fragment>
        )
    }
}

export default SnpPrimer
